module.exports = __webpack_public_path__ + "media/promo/courses/images/newm-e4bdf7d923e45d0eaf760735cee13351.jpg";